import Media from './Media'
import { serialize } from './helpers/serialize'

export enum NOTE_TYPE {
	Basic = 'basic',
	Transport = 'transport',
	Accommodation = 'accommodation',
	Transfer = 'transfer',
	Activity = 'activity',
	Internet = 'internet',
	Insurance = 'insurance',
	Visa = 'visa',
	Voucher = 'voucher',
}

export interface NoteData {
	title: string
	type: NOTE_TYPE
	description: string
	isEditable?: boolean
	mediaIds?: string[]
	id?: string | null
	data?: ExtraCategoryNote
	numMedias?: number
	isTemplate?: boolean
}

export type ExtraCategoryNote =
	| TransportNoteDetails
	| AccomodationNoteDetails
	| TransferNoteDetails
	| ActivityNoteDetails
	| VoucherNoteDetails

export type TransportNoteDetails = {
	origin?: string
	destination?: string
	departure?: Date
	arrival?: Date
	bookingNumber?: string
	reference?: string
}

export type AccomodationNoteDetails = {
	checkin?: Date
	checkout?: Date
	address?: string
	spotId?: string
}

export type TransferNoteDetails = {
	origin?: string
	destination?: string
	date?: Date
}

export type ActivityNoteDetails = {
	address?: string
	date?: Date
}

export type VoucherNoteDetails = {
	voucherUrl?: string
	fileUrl?: string
}

export type VoucherNote = Note2 & {
	data: VoucherNoteDetails
}

export type Note2 = {
	title: string
	type: NOTE_TYPE
	description: string
	isEditable?: boolean
	mediaIds?: string[]
	id?: string | null
	data?: ExtraCategoryNote
	numMedias?: number
	medias?: Media[]
	isTemplate?: boolean
}

export default class Note implements NoteData {
	title: string
	type: NOTE_TYPE
	description: string
	isEditable?: boolean
	mediaIds?: string[]
	id?: string | null
	data?:
		| TransportNoteDetails
		| AccomodationNoteDetails
		| TransferNoteDetails
		| ActivityNoteDetails
		| VoucherNoteDetails
	numMedias?: number
	medias?: Media[]
	isTemplate?: boolean

	constructor(note?: NoteData) {
		this.id = note?.id || null
		this.title = note?.title || ''
		this.type = (note?.type as NOTE_TYPE) || ''
		this.numMedias = note?.numMedias || 0
		this.mediaIds = serialize(Media, note?.mediaIds)
		this.description = note?.description || ''
		this.data = note?.data
		this.isEditable = note?.isEditable ?? true
		this.isTemplate = note?.isTemplate ?? false
	}
}
